import type React from 'react';

import { Breadcrumbs } from '@change/ds-core-ui';

import { CmsHtml } from '#src/app/shared/components/cms';

import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { html, styles, breadcrumbItems },
	} = usePageBody();

	return (
		<>
			<div className="[&_.business-model-icon]:w-17.5 md:[&_.business-model-icon]:w-23.5">
				<CmsHtml html={html} styles={styles} />
			</div>
			<div className="container mb-8">
				<Breadcrumbs items={breadcrumbItems} maxVisible={2} maxVisibleTablet={1} />
			</div>
		</>
	);
};
